/* eslint-disable no-nested-ternary */
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { useDispatch } from 'react-redux'

import { displayAlertAction } from 'src/comps/AlertMessage/actions'
import messages from 'src/comps/AlertMessage/messages'

export function getSeverityFromName(from) {
  if (/success/i.test(from)) return 'success'
  if (/error/i.test(from)) return 'error'
  if (/warning/i.test(from)) return 'warning'
  if (/info/i.test(from)) return 'info'
  if (/neutral/i.test(from)) return 'neutral'

  return 'neutral'
}

export function useAlertMessage() {
  const dispatch = useDispatch()

  const router = useRouter()
  const { from } = router.query

  useEffect(() => {
    const alerts = Object.keys(messages)
    const severity = getSeverityFromName(from)

    if (alerts.includes(from)) {
      dispatch(displayAlertAction({ messageId: from, severity }))
      router.replace(window.location.pathname, null, { shallow: true })
    }
  }, [dispatch, from, router])
}
